export default __webpack_public_path__ + "static/media/room3-MASK-industrial.89fe9f26.png";